import React, { useEffect } from 'react'
import Tween from '@tweenjs/tween.js'

function TypingIndicator () {
  useEffect(() => {
    setTween()
    return (
      () => {
        tweenRef.current = null
      }
    )
  }, [])

  const ref1 = React.useRef(null)
  const ref2 = React.useRef(null)
  const ref3 = React.useRef(null)
  const tweenRef = React.useRef(null)

  const values = { x: 0 }

  function setTween () {
    tweenRef.current = new Tween.Tween(values)
      .to({ x: 460 }, 1800)
      .onUpdate(() => {
        let x = values.x

        if (!ref1.current) {
          return
        }

        if (x <= 102) {
          const left = 204 - x
          ref1.current.style.setProperty('fill', `rgb(${left},${left},${left})`)
          ref2.current.style.setProperty('fill', 'rgb(204,204,204)')
          ref3.current.style.setProperty('fill', 'rgb(204,204,204)')
        } else if (x <= 204) {
          x = x % 102
          const left = 102 + x
          const right = 204 - x
          ref1.current.style.setProperty('fill', `rgb(${left},${left},${left})`)
          ref2.current.style.setProperty('fill', `rgb(${right},${right},${right})`)
          ref3.current.style.setProperty('fill', 'rgb(204,204,204)')
        } else if (x <= 306) {
          x = x % 102
          const left = 102 + x
          const right = 204 - x
          ref1.current.style.setProperty('fill', 'rgb(204,204,204)')
          ref2.current.style.setProperty('fill', `rgb(${left},${left},${left})`)
          ref3.current.style.setProperty('fill', `rgb(${right},${right},${right})`)
        } else if (x <= 408) {
          x = x % 102
          const left = 102 + x
          ref1.current.style.setProperty('fill', 'rgb(204,204,204)')
          ref2.current.style.setProperty('fill', 'rgb(204,204,204)')
          ref3.current.style.setProperty('fill', `rgb(${left},${left},${left})`)
        } else {
          ref1.current.style.setProperty('fill', 'rgb(204,204,204)')
          ref2.current.style.setProperty('fill', 'rgb(204,204,204)')
          ref3.current.style.setProperty('fill', 'rgb(204,204,204)')
        }
      })
      .start()
    tweenRef.current.repeat(Infinity)

    function animate (time) {
      requestAnimationFrame(animate)
      Tween.update(time)
    }
    requestAnimationFrame(animate)
  }

  return (
    <svg className='typing-dots' id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 51.29 39.95'>
      <title>Chat_Bubble_Typing</title>
      <path className='cls_1' d='M35.64,1H16.36a16,16,0,0,0-16,16V41l9.38-9.39v0A15.79,15.79,0,0,0,16.36,33H35.64a16,16,0,0,0,0-32Z' transform='translate(-0.36 -1.02)' />
      <circle cx={16} cy={15} r={4} ref={ref1} />
      <circle cx={26} cy={15} r={4} ref={ref2} />
      <circle cx={36} cy={15} r={4} ref={ref3} />
    </svg>
  )
}

export default TypingIndicator
